import * as React from 'react';
import {Modal, PrimaryButton, TextButton, CloseIcon} from '@liveoptics/react-ui';
import styled from '@emotion/styled';
import CloudCalcBaseModal from './CloudCalcBaseModal';
import ExclamationCircleIcon from '../svgs/ExclamationCircleIcon';

const ModalInnerWrap = styled.div`
    padding: 2rem;
`;

const ModalActionWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    margin-top: 25px;
`;

const ModalActionInner = styled.div`
    margin-right: 1rem;
`;

const RegionChangeConfirmationModal = ({modalTitle, nextRegion, closeFn, changeRegion}) => {
    let icon = (<ExclamationCircleIcon fill="#CE1126" />);

    return (
        <CloudCalcBaseModal modalTitle={modalTitle} modalIcon={icon} closeFn={closeFn}>
            <ModalInnerWrap>
                <div>
                    Are you sure you want to change your selected region? Doing so will delete all your VM configurations and start a new session.
                </div>
                <ModalActionWrap>
                    <ModalActionInner>
                        <TextButton clickFn={() => {changeRegion(nextRegion); closeFn();}}>Yes, Change Region</TextButton>
                    </ModalActionInner>
                    <PrimaryButton clickFn={closeFn}>Cancel</PrimaryButton>
                </ModalActionWrap>
            </ModalInnerWrap>
        </CloudCalcBaseModal>
    );
}

export default RegionChangeConfirmationModal;